import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';
import type { TemplateProject } from 'api/resources/templateProjects/types';

const useTemplateProject = ({
  id,
  options,
}: {
  id: string;
  options?: UseQueryOptions<
    Awaited<ReturnType<typeof api.getTemplateProject>>,
    unknown,
    Awaited<ReturnType<typeof api.getTemplateProject>>
  >;
}) => {
  const { methods } = useApi();

  return useQuery<TemplateProject>(
    ['template-project', id],
    () => methods.getTemplateProject(id),
    {
      ...options,
    },
  );
};

export default useTemplateProject;
